import type { RatesForLoanType } from './types/RatesForLoanType';
import { isRatesForBrand } from './isRatesForBrand';

const expectedBrands = ['autopay', 'rateGenius', 'tresl'];

export const isRatesForLoanType = (obj: unknown): obj is RatesForLoanType => {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }

  const brands = Object.keys(obj);

  const isInBrands = (brand: string) => brands.includes(brand);

  if (!expectedBrands.every(isInBrands)) {
    return false;
  }

  const isLoanRates = (brand: string) =>
    isRatesForBrand((obj as Record<string, unknown>)[brand]);

  return brands.every(isLoanRates);
};
